import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Play, Maximize2, Mars, MoveVertical, Weight, Maximize2Icon, Minimize2Icon, ChevronLeft, ChevronRight, ChevronDown } from 'lucide-react';
import { SbCurrentUser, getProfileHeightString, getProfileWeightString, humanize, isUndefinedNullEmpty } from '../submission_boards/component/SbModel';
import userSkillsService, { UserSkill } from '../services/UserSkillsService';
import mediaKitService from '../services/MediaKitService';
import FilePreviewer from '../submission_kits/components/FilePreviewer';
import { useIsMobile } from '../submission_boards/component/useIsMobile';
import overviewKitService from '../services/OverviewKitService';
import { showToast } from '../shared/Toast';
import { KitDocumentModel, OverviewKitDocumentModel } from '../submission_kits/components/KitModels';
import ViewMediaModel from '../submission_kits/components/ViewMediaModel';

// Add custom scrollbar styles
const scrollbarStyles = `
  .about-media-scroll::-webkit-scrollbar {
    height: 8px;
  }
  .about-media-scroll::-webkit-scrollbar-track {
    background: rgba(233, 238, 246, 0.5);
    border-radius: 4px;
  }
  .about-media-scroll::-webkit-scrollbar-thumb {
    background: rgba(140, 162, 194, 0.5);
    border-radius: 4px;
  }
  .about-media-scroll::-webkit-scrollbar-thumb:hover {
    background: rgba(140, 162, 194, 0.7);
  }
`;

interface AboutProps {
  currentUser: SbCurrentUser;
  user: any;
  showProfileHeader: (show:boolean) => void;
}

export const About: React.FC<AboutProps> = ({ currentUser, user, showProfileHeader }) => {
  const isMobile = useIsMobile();
  const [generalInformation, setGeneralInformation] = useState<string>('');
  const [skills, setSkills] = useState<UserSkill[]>([]);
  const [mediaType, setMediaType] = useState<'videos' | 'photos'>('videos');
  const [overviewKitDocuments, setOverviewKitDocuments] = useState<OverviewKitDocumentModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [showTopProfileHeader, setShowTopProfileHeader] = useState(true);
  const [currentMediaIndex, setCurrentMediaIndex] = useState<number>(0);
  const [currentMedia, setCurrentMedia] = useState([]);
  const [videos, setvideos] = useState([]);
  const [photos, setphotos] = useState([]);

  const [showMediaBig, setshowMediaBig] = useState<KitDocumentModel | null>(null);


  useEffect(() => {
    showProfileHeader(showTopProfileHeader);
  }, [showTopProfileHeader])
  useEffect(() => {
    loadOverview();
    fetchOverviewKitDocuments();
  }, []);

  const loadOverview = async () => {
    try {
      const response = await userSkillsService.getOverview(user?.uuid);
      if (response.success) {
        setGeneralInformation(response.general_information || '');
        setSkills(response.skills || []);
      }
    } catch (err) {
      console.error('Error loading overview:', err);
    }
  };

  const fetchOverviewKitDocuments = async () => {
    try {
      setLoading(true);
      const response = await overviewKitService.getOverviewKitDocuments(user?.uuid);
      if (response.status === 'success') {
        setOverviewKitDocuments(response.overview_kit_documents || []);
        const _videos = response.overview_kit_documents.filter(doc => doc.kit_document.file_content_type?.startsWith('video'));
        setvideos(_videos);
        const _photos = response.overview_kit_documents.filter(doc => doc.kit_document.file_content_type?.startsWith('image'));
        setphotos(_photos);
        if (_videos.length > 0) {
          setMediaType("videos");
        } else if (_photos.length > 0) {
          setMediaType("photos");
        }        
        // if (mediaType === 'videos' && _videos.length > 0) {
        //   setCurrentMedia(_videos);
        // } else if (_photos.length > 0) {
        //   setCurrentMedia(_photos);
        // }
      }
    } catch (error) {
      showToast('Error fetching Overview Media.', 'danger');
    } finally {
      setLoading(false);
    }
  };
  // const loadMediaKits = async () => {
  //   try {
  //     // const response = await mediaKitService.fetchMediaKits('', 'new', 1, 999);
  //     const response = await mediaKitService.fetchMediaKits('', 'new', 1, 999, user?.uuid);
  //     if (response && response.kit_documents) {
  //       setMediaKitDocuments(response.kit_documents || []);
  //     }
  //   } catch (err) {
  //     console.error('Error loading media kits:', err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const videos = overviewKitDocuments.filter(doc => doc.kit_document.file_content_type?.startsWith('video'));
  // // const photo = [
  // //   {
  // //     file_url: user.cropped_avatar_url || user.avatar_url,
  // //     file_content_type: 'image/jpg',
  // //     file_name: 'profile_photo'
  // //   } ]
  // // const photos = [
  // //   ...photo,
  // //   ...mediaKitDocuments.filter(doc => doc.file_content_type?.startsWith('image'))];
  // const photos = overviewKitDocuments.filter(doc => doc.kit_document.file_content_type?.startsWith('image'));
  // Reset index when media type changes
  useEffect(() => {
    setCurrentMediaIndex(0);
    // if (mediaType === 'videos' && videos.length > 0) {
    // console.log("currentMedia set videos ", videos);
    // setCurrentMedia(videos);
    // setMediaType("videos");
    // } else if (photos.length > 0) {
    // console.log("currentMedia set photos ", photos);
    // setCurrentMedia(photos);
    // setMediaType("photos");
    // }
  }, [mediaType]);
  // useEffect(() => {
  //  console.log("currentMedia All ", currentMedia);
  // }, [currentMedia]);
  // let currentMedia = [];
  // if (mediaType === 'videos' && videos.length > 0) {
  //   currentMedia = videos;
  //   // setMediaType("videos");
  // } else if (photos.length > 0) {
  //   currentMedia = photos;
  //   // setMediaType("photos");
  // }


  const handlePreviousMedia = () => {
    if (mediaType === 'photos' && photos.length > 1) {
      setCurrentMediaIndex((prev) => (prev > 0 ? prev - 1 : photos.length - 1));
    } else if (mediaType === 'videos' && videos.length > 1) {
      setCurrentMediaIndex((prev) => (prev > 0 ? prev - 1 : videos.length - 1));
    }
  };

  const handleNextMedia = () => {
    if (mediaType === 'photos' && photos.length > 1) {
      setCurrentMediaIndex((prev) => (prev < photos.length - 1 ? prev + 1 : 0));
    } else if (mediaType === 'videos' && videos.length > 1) {
      setCurrentMediaIndex((prev) => (prev < videos.length - 1 ? prev + 1 : 0));
    }
  };

  // Helper function to format ethnicity
  const formatEthnicity = () => {
    if (!user?.ethnicities || user.ethnicities.length === 0) return '';
    return user.ethnicities.map((e: string) => humanize(e)).join(', ');
  };

  const gridBoxItem = (title, value, icon: React.ReactNode) => {
    return (
      <div
        className="flex flex-col justify-start items-center gap-2-1 border border-blue-502 "
        style={{
          padding: '0.375rem',
          borderRadius: '0.625rem',
          color: '#8CA2C280',
          backgroundColor: '#E9EEF6D9',
        }}
      >
        {title != null && (
          <div
            className="flex flex-col justify-end items-center gap-2-1 bg-white w-full"
            style={{
              padding: '0.75rem 0.5rem 0.375rem',
              borderRadius: '0.375rem 0.375rem 0.125rem 0.125rem',
            }}
          >
            <div className="font-normal font-semibold text-13 text-center text-blue-403">
              {title}
            </div>
          </div>
        )}
        <div className="flex flex-col justify--center items-start gap-2-1">
          <div
            className=" flex flex-row justify--center items-center gap-2-1 px-5 py-2-1 text-lg primary-color"
            style={{
              minHeight: '1.875rem',
            }}
          >
            {icon != null && <div id="icon">{icon}</div>}
            <div>{isUndefinedNullEmpty(value) ? '-' : value}</div>
          </div>
        </div>
      </div>
    );
  };

  const listBoxItem = (title, value) => {
    return (
      <div className="flex flex-col items-start p-0">
        {title != null && (
          <div
            className="flex flex-row  gap-2-1 w-full"
            style={{
              paddingTop: '0.1875rem',
            }}
          >
            <div className="text-13 font-medium text-left text-blue-403">{title}</div>
          </div>
        )}
        <div className="flex flex-col primary-color font-regular text-lg">{value}</div>
      </div>
    );
  };
  // media slider
  const panelRef = useRef(null);
  const MIN_SWIPE_DISTANCE = 50; // Distance in pixels to confirm a swipe-down close
  const [dragYMedia, setDragYMedia] = useState(0); // Tracks vertical drag distance (for visual feedback)
  // const touchStartY = useRef(0); // Stores the Y position when the touch starts
  const touchStartMedia = useRef({ x: 0, y: 0 });
  const handleTouchStartMedia = (e) => {
    e.stopPropagation();
    // Only track single touch starts on the dialog panel itself
    if (e.touches.length === 1) {
      touchStartMedia.current = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
      };
      setDragYMedia(0); // Reset drag distance
      panelRef.current.style.transition = 'none'; // Disable transition during drag
    }
  };

  const handleTouchMoveMedia = useCallback((e) => {
    e.stopPropagation();
    if (e.touches.length !== 1) return;

    const currentY = e.touches[0].clientY;
    const deltaY = currentY - touchStartMedia.current.y;

    // Only allow downward swiping (deltaY > 0)
    if (deltaY > 0) {
      //e.preventDefault(); // Prevent scrolling the main page while dragging the dialog
      setDragYMedia(deltaY);

      // Apply immediate visual translation via inline style
      // if (panelRef.current) {
      //   panelRef.current.style.transform = `translateY(${deltaY}px)`;
      // }
    }
  }, []);

  const handleTouchEndMedia = useCallback(
    (e) => {
      e.stopPropagation();
      if (e.changedTouches.length === 0) return;

      // Get the final touch position
      const touchEnd = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY,
      };

      // Calculate the total change in coordinates
      const deltaX = touchEnd.x - touchStartMedia.current.x;
      const deltaY = touchEnd.y - touchStartMedia.current.y;

      // Calculate the absolute distance moved in each axis
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // --- Check for a deliberate swipe (must move more than the minimum distance) ---
      if (absDeltaX < MIN_SWIPE_DISTANCE && absDeltaY < MIN_SWIPE_DISTANCE) {
        // console.log('Only a small movement (tap or minor drag).');
        return;
      }

      // --- 1. Determine DOMINANT axis ---
      if (absDeltaX > absDeltaY) {
        // Horizontal swipe is dominant
        if (deltaX > 0) {
          handlePreviousMedia();
          // setCurrentMediaIndex((prev) => (prev > 0 ? prev - 1 : currentMedia.length - 1));
        } else {
          handleNextMedia();
          // setCurrentMediaIndex((prev) => (prev < currentMedia.length - 1 ? prev + 1 : 0));
        }
      } else {
      }
      setDragYMedia(0);
    },
    [dragYMedia]
  );

  // media slider end  
  return (
    <>
      <style>{scrollbarStyles}</style>
      <div
        className="flex flex-col bg-white rounded-2xl border border-blue-502 "
        style={{
          paddingTop: isMobile ? '2.5rem' : '2.5rem', // 40px 60px
          paddingBottom: isMobile ? '2.5rem' : '2.5rem', // 60px
          paddingLeft: isMobile ? '1.25rem' : '3.75rem', // 20px 60px
          paddingRight: isMobile ? '1.25rem' : '3.75rem', // 60px
          gap: isMobile ? '2.5rem' : '2.5rem', // 60px
        }}
      >
        {/* Profile Module Header */}
        <div
          className="box-border flex flex-row items-center pb-2.5 gap-4 w-full h-14 border-b"
          style={{ borderBottomColor: 'rgba(140, 162, 194, 0.5)' }}
        >
          <h1
            className={`w-full flex-1 m-0 ${isMobile ? 'h-auto text-2xl leading-9 text-center' : 'h-12 text-3xl leading-12 '
              } font-medium tracking-tight`}
            style={{ color: '#576C89' }}
          >
            About
          </h1>
          <button
            className="hidden w-21 h-8 rounded-full border-none cursor-pointer"
            style={{ background: 'rgba(60, 130, 246, 0.25)' }}
          />
          {showTopProfileHeader ? (
            <div
              className="w-7 h-7 cursor-pointer hidden sm:flex items-center justify-center overflow-hidden"
              style={{
                color: '#576C89',
              }}
              onClick={() => {
                setShowTopProfileHeader(false);
              }}
            >
              <Maximize2Icon className="w-7 h-7" />
            </div>
          ) : (
            <div
              className="w-7 h-7 cursor-pointer hidden sm:flex items-center justify-center overflow-hidden"
              style={{
                color: '#576C89',
              }}
              onClick={() => {
                setShowTopProfileHeader(true);
              }}
            >
              <Minimize2Icon className="w-7 h-7" />
            </div>
          )}
        </div>

        {/* Media Section - Desktop: after header, Mobile: after personal info */}
        {((user?.show_bio_skills ?? true) || currentUser?.uuid === user?.uuid) && !isMobile && (photos.length > 0 || videos.length > 0) && (
          <div className="flex flex-col items-start p-0 gap-5 w-full">
            <div className="flex flex-row justify-between items-start p-0 gap-2 w-full min-w-0 h-9">
              <h2
                className="flex-1 min-w-0 h-7 font-semibold text-xl leading-7"
                style={{ color: '#0D1621' }}
              >
                Media
              </h2>
              <div className="flex flex-row items-start p-0 gap-1 h-9 flex-shrink-0 w-auto min-w-0">
                {videos.length > 0 && (
                  <button
                    onClick={() => setMediaType('videos')}
                    className="flex items-center justify-center px-3 py-2 gap-2 w-24 rounded-lg cursor-pointer font-medium text-xs leading-5 whitespace-nowrap overflow-hidden text-ellipsis"
                    style={{
                      background: mediaType === 'videos' ? 'rgba(60, 130, 246, 0.15)' : '#FFFFFF',
                      border:
                        mediaType === 'videos'
                          ? '1px solid #3C82F6'
                          : '1px solid rgba(140, 162, 194, 0.5)',
                      color: '#0D1621',
                    }}
                  >
                    Videos ({videos.length})
                  </button>
                )}

                {photos.length > 0 && (
                  <button
                    onClick={() => setMediaType('photos')}
                    className="flex items-center justify-center px-3 py-2 gap-2 w-24 rounded-lg cursor-pointer font-medium text-xs leading-5 whitespace-nowrap overflow-hidden text-ellipsis"
                    style={{
                      background: mediaType === 'photos' ? 'rgba(60, 130, 246, 0.15)' : '#FFFFFF',
                      border:
                        mediaType === 'photos'
                          ? '1px solid #3C82F6'
                          : '1px solid rgba(140, 162, 194, 0.5)',
                      color: '#0D1621',
                    }}
                  >
                    Photos ({photos.length})
                  </button>
                )}
              </div>
            </div>

            {/* Media Grid - Horizontally Scrollable */}
            <div className="flex flex-col items-start p-0 gap-3 w-full">
              <div
                className="about-media-scroll flex flex-row items-center p-0 gap-2.5 w-full overflow-x-auto overflow-y-hidden"
                style={{
                  scrollBehavior: 'smooth',
                  WebkitOverflowScrolling: 'touch',
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#8CA2C2 transparent',
                }}
              >
                {mediaType == 'photos' && photos.length === 0 && (
                  <div
                    className="w-full flex items-center justify-center"
                    style={{ color: '#576C89', height: isMobile ? '200px' : '320px' }}
                  >
                    No {mediaType} available
                  </div>
                )}
                {mediaType == 'photos' &&
                  photos.map(
                    (doc, index) => (
                      console.log('currentmedia', doc),
                      (
                        <div
                          key={index}
                          className="flex flex-row justify-center items-center p-0 gap-2.5 rounded-xl relative overflow-hidden flex-shrink-0"
                          style={{
                            width: isMobile
                              ? '17.5rem'
                              : doc.kit_document.file_content_type?.startsWith('video')
                              ? '30rem'
                              : 'unset',
                            aspectRatio: doc.kit_document.file_content_type?.startsWith('image')
                              ? '4/5'
                              : 'unset',
                            height: isMobile ? '12.5rem' : '20rem',
                          }}
                        >
                          <div
                            className="w-full h-full relative"
                            onClick={(e) => {
                              e.preventDefault();
                              setshowMediaBig(doc.kit_document);
                            }}
                          >
                            <FilePreviewer
                              showControl={true}
                              dynamicHeight={false}
                              object_fit="object-cover"
                              file_url={
                                doc.kit_document.cropped_file_url || doc.kit_document.file_url
                              }
                              file_name={doc.kit_document.file_name}
                              file_content_type={doc.kit_document.file_content_type}
                            />
                            {/* {doc.file_content_type?.startsWith('video') && (
                    <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 box-border flex flex-col justify-center items-start p-3 gap-2.5 rounded-full cursor-pointer ${isMobile ? 'w-10 h-10' : 'w-12 h-12'}`} style={{ background: 'rgba(0, 0, 0, 0.2)', border: '1px solid #FFFFFF' }}>
                      <Play size={isMobile ? 20 : 24} color="#FFFFFF" fill="#FFFFFF" />
                    </div>
                  )} */}
                          </div>
                        </div>
                      )
                    )
                  )}

                {mediaType == 'videos' && videos.length === 0 && (
                  <div
                    className="w-full flex items-center justify-center"
                    style={{ color: '#576C89', height: isMobile ? '200px' : '320px' }}
                  >
                    No {mediaType} available
                  </div>
                )}

                {mediaType == 'videos' &&
                  videos.map(
                    (doc, index) => (
                      console.log('currentmedia', doc),
                      (
                        <div
                          key={index}
                          className="flex flex-row justify-center items-center p-0 gap-2.5 rounded-xl relative overflow-hidden flex-shrink-0"
                          style={{
                            width: isMobile
                              ? '17.5rem'
                              : doc.kit_document.file_content_type?.startsWith('video')
                              ? '30rem'
                              : 'unset',
                            aspectRatio: doc.kit_document.file_content_type?.startsWith('image')
                              ? '4/5'
                              : 'unset',
                            height: isMobile ? '12.5rem' : '20rem',
                          }}
                        >
                          <div
                            className="w-full h-full relative"
                            onClick={(e) => {
                              e.preventDefault();
                              setshowMediaBig(doc.kit_document);
                            }}
                          >
                            <FilePreviewer
                              showControl={false}
                              dynamicHeight={false}
                              object_fit="object-cover"
                              // file_url={
                              //   doc.kit_document.cropped_file_url || doc.kit_document.file_url
                              // }
                                file_url={
                                    doc.kit_document.file_content_type.startsWith('image') ? 
                                    (doc.kit_document.cropped_file_url ??
                                    doc.kit_document.file_url) : 
                                    doc.kit_document.file_url
                                    
                                  }
                                  poster_url={
                                    doc.kit_document.file_content_type.startsWith('image') ? '' : 
                                    doc.kit_document.cropped_file_url
                                  }

                              file_name={doc.kit_document.file_name}
                              file_content_type={doc.kit_document.file_content_type}
                            />
                            {/* {doc.file_content_type?.startsWith('video') && (
                      <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 box-border flex flex-col justify-center items-start p-3 gap-2.5 rounded-full cursor-pointer ${isMobile ? 'w-10 h-10' : 'w-12 h-12'}`} style={{ background: 'rgba(0, 0, 0, 0.2)', border: '1px solid #FFFFFF' }}>
                        <Play size={isMobile ? 20 : 24} color="#FFFFFF" fill="#FFFFFF" />
                      </div>
                    )} */}
                          </div>
                        </div>
                      )
                    )
                  )}
              </div>
            </div>
          </div>
        )}

        {/* Personal Information Section */}
        <div
          className={`flex ${isMobile ? 'flex-col' : 'flex-col'} items-start p-0 w-full flex-wrap ${isMobile ? 'gap-3' : 'gap-1'
            }`}
        >
          {/* Row 1 - Feature label only on mobile */}
          {isMobile ? (
            <>
              <div
                className={`w-full flex-1 m-0 h-auto leading-9 font-semibold tracking-tight text-xl`}
                style={{ color: '#0D1621' }}
              >
                Feature
              </div>
              <div className="gap-1 flex flex-col flex-1 w-full">
                <div className="grid grid-cols-1 gap-1 flex-1 w-full">
                  {gridBoxItem(
                    'Gender',
                    user?.gender ? humanize(user.gender) : '',
                    <Mars className="w-4 h-4 text-blue-403" />
                  )}
                </div>
              </div>
              {!user.is_prod_support_onboarding && <div className="gap-1 flex flex-col flex-1 w-full">
                <div className="grid grid-cols-2 gap-1 flex-1 w-full">
                  {gridBoxItem(
                    'Height',
                    getProfileHeightString(user, currentUser),
                    <MoveVertical className="w-4 h-4 text-blue-403" />
                  )}
                  {gridBoxItem(
                    'Weight',
                    getProfileWeightString(user, currentUser),
                    <Weight className="w-4 h-4 text-blue-403" />
                  )}
                </div>
              </div>}
              <div className="gap-1 flex flex-col flex-1 w-full">
                <div className="grid grid-cols-2 gap-1 flex-1 w-full">
                  {gridBoxItem(
                    'Hair',
                    user?.hair_make_up_kit?.hair_color
                      ? humanize(user.hair_make_up_kit.hair_color)
                      : '',
                    null
                  )}
                  {gridBoxItem(
                    'Eyes',
                    user?.hair_make_up_kit?.eye_color
                      ? humanize(user.hair_make_up_kit.eye_color)
                      : '',
                    null
                  )}
                </div>
              </div>
              {!user.is_prod_support_onboarding && <div className="gap-1 flex flex-col flex-1 w-full">
                <div className="grid grid-cols-1 gap-1 flex-1 w-full">
                  {gridBoxItem('Ethnicity', formatEthnicity(), null)}
                </div>
              </div>}
            </>
          ) : (
            <>
              <div className="gap-1 flex flex-col flex-1 w-full">
                <div className="grid grid-cols-3 gap-1 flex-1 w-full">
                  {gridBoxItem(
                    'Gender',
                    user?.gender ? humanize(user.gender) : '',
                    <Mars className="w-4 h-4 text-blue-403" />
                  )}
                  {!user.is_prod_support_onboarding && gridBoxItem(
                    'Height',
                    getProfileHeightString(user, currentUser),
                    <MoveVertical className="w-4 h-4 text-blue-403" />
                  )}
                  {!user.is_prod_support_onboarding && gridBoxItem(
                    'Weight',
                    getProfileWeightString(user, currentUser),
                    <Weight className="w-4 h-4 text-blue-403" />
                  )}
                </div>
              </div>
              <div className="gap-1 flex flex-col flex-1 w-full">
                <div className="grid grid-cols-3 gap-1 flex-1 w-full">
                  {gridBoxItem(
                    'Hair',
                    user?.hair_make_up_kit?.hair_color
                      ? humanize(user.hair_make_up_kit.hair_color)
                      : '',
                    null
                  )}
                  {gridBoxItem(
                    'Eyes',
                    user?.hair_make_up_kit?.eye_color
                      ? humanize(user.hair_make_up_kit.eye_color)
                      : '',
                    null
                  )}
                  {!user.is_prod_support_onboarding && gridBoxItem('Ethnicity', formatEthnicity(), null)}
                </div>
              </div>
            </>
          )}
        </div>
        {/* <div className={`flex flex-col items-start p-1.5 gap-2.5 rounded-lg ${isMobile ? 'w-full h-auto flex-none min-w-full' : 'flex-1'}`} style={{ 
          background: 'rgba(233, 238, 246, 0.85)', 
          border: '1px solid rgba(140, 162, 194, 0.5)',
          width: isMobile ? '100%' : '324px',
          height: isMobile ? 'auto' : '104px',
          minHeight: isMobile ? '90px' : '104px',
          minWidth: isMobile ? '100%' : '300px'
        }}>
          <div className="flex flex-col justify-end items-center px-2 pt-3 pb-1.5 gap-2.5 w-full h-9 bg-white rounded-t-md rounded-b-sm">
            <div className={`w-full h-4 font-semibold text-center leading-tight ${isMobile ? 'text-xs' : 'text-xs'}`} style={{ color: '#576C89' }}>
              Gender
            </div>
          </div>
          <div className="flex flex-row justify-center items-center px-5 py-2.5 gap-1.5 w-full h-12">
            <Mars size={isMobile ? 14 : 16} color="#576C89" />
            <div className="font-normal text-lg leading-relaxed text-center" style={{ color: '#0D1621' }}>
              {user?.gender ? humanize(user.gender) : ''}
            </div>
          </div>
        </div> 

        <div className={`flex flex-col items-start p-1.5 gap-2.5 rounded-lg ${isMobile ? 'w-full h-auto flex-none min-w-full' : 'flex-1'}`} style={{ 
          background: 'rgba(233, 238, 246, 0.85)', 
          border: '1px solid rgba(140, 162, 194, 0.5)',
          width: isMobile ? '100%' : '324px',
          height: isMobile ? 'auto' : '104px',
          minHeight: isMobile ? '90px' : '104px',
          minWidth: isMobile ? '100%' : '300px'
        }}>
          <div className="flex flex-col justify-end items-center px-2 pt-3 pb-1.5 gap-2.5 w-full h-9 bg-white rounded-t-md rounded-b-sm">
            <div className={`w-full h-4 font-semibold text-center leading-tight ${isMobile ? 'text-xs' : 'text-xs'}`} style={{ color: '#576C89' }}>
              Height
            </div>
          </div>
          <div className="flex flex-row justify-center items-center px-5 py-2.5 gap-1.5 w-full h-12 min-h-8">
            <MoveVertical size={isMobile ? 14 : 16} color="#576C89" />
            <div className={`font-normal flex items-center leading-relaxed ${isMobile ? 'text-base' : 'text-lg'}`} style={{ color: '#0D1621' }}>
              {getProfileHeightString(user, currentUser) || ''}
            </div>
          </div>
        </div>

        <div className={`flex flex-col items-start p-1.5 gap-2.5 rounded-lg ${isMobile ? 'w-full h-auto flex-none min-w-full' : 'flex-1'}`} style={{ 
          background: 'rgba(233, 238, 246, 0.85)', 
          border: '1px solid rgba(140, 162, 194, 0.5)',
          width: isMobile ? '100%' : '324px',
          height: isMobile ? 'auto' : '104px',
          minHeight: isMobile ? '90px' : '104px',
          minWidth: isMobile ? '100%' : '300px'
        }}>
          <div className="flex flex-col justify-end items-center px-2 pt-3 pb-1.5 gap-2.5 w-full h-9 bg-white rounded-t-md rounded-b-sm">
            <div className={`w-full h-4 font-semibold text-center leading-tight ${isMobile ? 'text-xs' : 'text-xs'}`} style={{ color: '#576C89' }}>
              Weight
            </div>
          </div>
          <div className="flex flex-row justify-center items-center px-5 py-2.5 gap-1.5 w-full h-12 min-h-8">
            <Weight size={isMobile ? 14 : 16} color="#576C89" />
            <div className={`font-normal flex items-center leading-relaxed ${isMobile ? 'text-base' : 'text-lg'}`} style={{ color: '#0D1621' }}>
              {getProfileWeightString(user, currentUser) || ''}
            </div>
          </div>
        </div>

        <div className={`flex flex-col items-start p-1.5 gap-2.5 rounded-lg ${isMobile ? 'w-full h-auto flex-none min-w-full' : 'flex-1'}`} style={{ 
          background: 'rgba(233, 238, 246, 0.85)', 
          border: '1px solid rgba(140, 162, 194, 0.5)',
          width: isMobile ? '100%' : '324px',
          height: isMobile ? 'auto' : '104px',
          minHeight: isMobile ? '90px' : '104px',
          minWidth: isMobile ? '100%' : '300px'
        }}>
          <div className="flex flex-col justify-end items-center px-2 pt-3 pb-1.5 gap-2.5 w-full h-9 bg-white rounded-t-md rounded-b-sm">
            <div className={`w-full h-4 font-semibold text-center leading-tight ${isMobile ? 'text-xs' : 'text-xs'}`} style={{ color: '#576C89' }}>
              Hair
            </div>
          </div>
          <div className="flex flex-row justify-center items-center px-5 py-2.5 gap-1.5 w-full h-12">
            <div className={`font-normal flex items-center leading-relaxed ${isMobile ? 'text-base' : 'text-lg'}`} style={{ color: '#0D1621' }}>
              {user?.hair_make_up_kit?.hair_color ? humanize(user.hair_make_up_kit.hair_color) : ''}
            </div>
          </div>
        </div>

        <div className={`flex flex-col items-start p-1.5 gap-2.5 rounded-lg ${isMobile ? 'w-full h-auto flex-none min-w-full' : 'flex-1'}`} style={{ 
          background: 'rgba(233, 238, 246, 0.85)', 
          border: '1px solid rgba(140, 162, 194, 0.5)',
          width: isMobile ? '100%' : '324px',
          height: isMobile ? 'auto' : '104px',
          minHeight: isMobile ? '90px' : '104px',
          minWidth: isMobile ? '100%' : '300px'
        }}>
          <div className="flex flex-col justify-end items-center px-2 pt-3 pb-1.5 gap-2.5 w-full h-9 bg-white rounded-t-md rounded-b-sm">
            <div className={`w-full h-4 font-semibold text-center leading-tight ${isMobile ? 'text-xs' : 'text-xs'}`} style={{ color: '#576C89' }}>
              Eyes
            </div>
          </div>
          <div className="flex flex-row justify-center items-center px-5 py-2.5 gap-1.5 w-full h-12">
            <div className={`font-normal flex items-center leading-relaxed ${isMobile ? 'text-base' : 'text-lg'}`} style={{ color: '#0D1621' }}>
              {user?.hair_make_up_kit?.eye_color ? humanize(user.hair_make_up_kit.eye_color) : ''}
            </div>
          </div>
        </div>

        <div className={`flex flex-col items-start p-1.5 gap-2.5 rounded-lg ${isMobile ? 'w-full h-auto flex-none min-w-full' : 'flex-1'}`} style={{ 
          background: 'rgba(233, 238, 246, 0.85)', 
          border: '1px solid rgba(140, 162, 194, 0.5)',
          width: isMobile ? '100%' : '324px',
          height: isMobile ? 'auto' : 'auto',
          minHeight: isMobile ? '90px' : '104px',
          minWidth: isMobile ? '100%' : '300px'
        }}>
          <div className="flex flex-col justify-end items-center px-2 pt-3 pb-1.5 gap-2.5 w-full h-9 bg-white rounded-t-md rounded-b-sm">
            <div className={`w-full h-4 font-semibold text-center leading-tight ${isMobile ? 'text-xs' : 'text-xs'}`} style={{ color: '#576C89' }}>
              Ethnicity
            </div>
          </div>
          <div className="flex flex-col justify-center items-center px-5 py-2.5 gap-1.5 w-full min-h-8">
            <div className={`font-normal flex flex-col items-center justify-center leading-relaxed text-center w-full min-w-0 ${isMobile ? 'text-base' : 'text-lg'}`} style={{ color: '#0D1621' }}>
              <div className="w-full text-center break-words overflow-wrap-anywhere">
                {formatEthnicity()}
              </div>
            </div>
          </div>
        </div>

        {/* Media Section - Mobile: after personal info */}
        {((user?.show_bio_skills ?? true) || currentUser?.uuid === user?.uuid) &&
          isMobile && (photos.length > 0 || videos.length > 0) && (
            <div className="flex flex-col items-start p-0 gap-3 w-full">
              <div className="flex flex-row items-center gap-3 w-full">
                <h2
                  className="flex-none font-semibold text-xl leading-7"
                  style={{ color: '#0D1621' }}
                >
                  Media
                </h2>
                <div className="flex flex-row items-center gap-1 flex-1 justify-end">
                  {videos.length > 0 && (
                    <button
                      onClick={() => setMediaType('videos')}
                      className="box-border flex flex-row items-center justify-center px-3 py-2 gap-2 rounded-lg cursor-pointer font-medium text-xs leading-5 whitespace-nowrap transition-colors"
                      style={{
                        background: mediaType === 'videos' ? 'rgba(60, 130, 246, 0.15)' : '#FFFFFF',
                        border:
                          mediaType === 'videos'
                            ? '1px solid rgba(60, 130, 246, 0.3)'
                            : '1px solid rgba(140, 162, 194, 0.5)',
                        color: mediaType === 'videos' ? '#0D1621' : '#0D1621',
                        minWidth: 'fit-content',
                      }}
                    >
                      Videos ({videos.length})
                    </button>
                  )}
                  {photos.length > 0 && (
                    <button
                      onClick={() => setMediaType('photos')}
                      className="box-border flex flex-row items-center justify-center px-3 py-2 gap-2 rounded-lg cursor-pointer font-medium text-xs leading-5 whitespace-nowrap transition-colors"
                      style={{
                        background: mediaType === 'photos' ? 'rgba(60, 130, 246, 0.15)' : '#FFFFFF',
                        border:
                          mediaType === 'photos'
                            ? '1px solid rgba(60, 130, 246, 0.3)'
                            : '1px solid rgba(140, 162, 194, 0.5)',
                        color: mediaType === 'photos' ? '#0D1621' : '#0D1621',
                        minWidth: 'fit-content',
                      }}
                    >
                      Photos ({photos.length})
                    </button>
                  )}
                </div>
              </div>

              {mediaType == 'photos' && photos.length > 0 && (
                <div className="flex flex-col items-start p-0 gap-3 w-full">
                  <div
                    className="w-full rounded-xl relative overflow-hidden"
                    style={
                      {
                        // height: '280px'
                      }
                    }
                    ref={panelRef}
                    onTouchStart={handleTouchStartMedia}
                    onTouchMove={handleTouchMoveMedia}
                    onTouchEnd={handleTouchEndMedia}
                  >
                    <div
                      className="w-full h-full relative"
                      style={
                        {
                          // aspectRatio:mediaType === photos[currentMediaIndex].kit_document.file_content_type?.startsWith('video') ?16/9:4/5
                        }
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setshowMediaBig(photos[currentMediaIndex].kit_document);
                      }}
                    >
                      <FilePreviewer
                        showControl={true}
                        key={`media-${currentMediaIndex}-${photos[currentMediaIndex]?.id ||
                          photos[currentMediaIndex]?.kit_document.file_url ||
                          currentMediaIndex
                          }`}
                        dynamicHeight={true}
                        object_fit="object-cover "
                        file_url={
                          photos[currentMediaIndex].kit_document.cropped_file_url ||
                          photos[currentMediaIndex].kit_document.file_url
                        }
                        file_name={photos[currentMediaIndex].kit_document.file_name}
                        file_content_type={
                          photos[currentMediaIndex].kit_document.file_content_type
                        }
                      />
                    </div>
                  </div>

                  {/* Media count label - Centered */}
                  <div
                    className="flex-none order-0 self-stretch flex-grow-0 text-center "
                    style={{ color: '#0D1621', lineHeight: '1.875rem' }}
                  >
                    Media ({photos.length})
                  </div>

                  {/* Pagination with arrows and dots */}
                  {photos.length > 1 && (
                    <div className="flex flex-row items-center justify-center gap-2 w-full py-2">
                      <button
                        onClick={handlePreviousMedia}
                        className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 hover:bg-gray-50 transition-colors"
                        aria-label="Previous media"
                      >
                        <ChevronLeft size={20} color="#4B5563" />
                      </button>
                      <div className="flex flex-row items-center gap-2">
                        {photos.map((_, index) => (
                          <div
                            key={index}
                            className={`rounded-full transition-all ${index === currentMediaIndex
                              ? 'w-2 h-2 bg-blue-500'
                              : 'w-1.5 h-1.5 bg-gray-300'
                              }`}
                          />
                        ))}
                      </div>
                      <button
                        onClick={handleNextMedia}
                        className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 hover:bg-gray-50 transition-colors"
                        aria-label="Next media"
                      >
                        <ChevronRight size={20} color="#4B5563" />
                      </button>
                    </div>
                  )}
                </div>
              )}
              {mediaType == 'photos' && photos.length === 0 && (
                <div
                  style={{
                    width: '100%',
                    // height: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#576C89',
                    height: '12.5rem',
                  }}
                >
                  No {mediaType} available
                </div>
              )}
              {mediaType == 'videos' && videos.length > 0 && (
                <div className="flex flex-col items-start p-0 gap-3 w-full">
                  <div
                    className="w-full rounded-xl relative overflow-hidden"
                    style={
                      {
                        // height: '280px'
                      }
                    }
                    ref={panelRef}
                    onTouchStart={handleTouchStartMedia}
                    onTouchMove={handleTouchMoveMedia}
                    onTouchEnd={handleTouchEndMedia}
                  >
                    <div
                      className="w-full h-full relative"
                      style={
                        {
                          // aspectRatio:mediaType === currentMedia[currentMediaIndex].kit_document.file_content_type?.startsWith('video') ?16/9:4/5
                        }
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setshowMediaBig(videos[currentMediaIndex].kit_document);
                      }}
                    >
                      <FilePreviewer
                        showControl={true}
                        key={`media-${currentMediaIndex}-${videos[currentMediaIndex]?.id ||
                          videos[currentMediaIndex]?.kit_document.file_url ||
                          currentMediaIndex
                          }`}
                        dynamicHeight={true}
                        object_fit="object-cover "
                        // file_url={
                        //   videos[currentMediaIndex].kit_document.cropped_file_url ||
                        //   videos[currentMediaIndex].kit_document.file_url
                        // }
                        file_url={
                            videos[currentMediaIndex].kit_document.file_content_type.startsWith('image') ? 
                            (videos[currentMediaIndex].kit_document.cropped_file_url ??
                            videos[currentMediaIndex].kit_document.file_url) : 
                            videos[currentMediaIndex].kit_document.file_url
                            
                          }
                          poster_url={
                            videos[currentMediaIndex].kit_document.file_content_type.startsWith('image') ? '' : 
                            videos[currentMediaIndex].kit_document.cropped_file_url
                          }
                        file_name={videos[currentMediaIndex].kit_document.file_name}
                        file_content_type={
                          videos[currentMediaIndex].kit_document.file_content_type
                        }
                      />
                    </div>
                  </div>

                  {/* Media count label - Centered */}
                  <div
                    className="flex-none order-0 self-stretch flex-grow-0 text-center "
                    style={{ color: '#0D1621', lineHeight: '1.875rem' }}
                  >
                    Media ({videos.length})
                  </div>

                  {/* Pagination with arrows and dots */}
                  {videos.length > 1 && (
                    <div className="flex flex-row items-center justify-center gap-2 w-full py-2">
                      <button
                        onClick={handlePreviousMedia}
                        className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 hover:bg-gray-50 transition-colors"
                        aria-label="Previous media"
                      >
                        <ChevronLeft size={20} color="#4B5563" />
                      </button>
                      <div className="flex flex-row items-center gap-2">
                        {videos.map((_, index) => (
                          <div
                            key={index}
                            className={`rounded-full transition-all ${index === currentMediaIndex
                              ? 'w-2 h-2 bg-blue-500'
                              : 'w-1.5 h-1.5 bg-gray-300'
                              }`}
                          />
                        ))}
                      </div>
                      <button
                        onClick={handleNextMedia}
                        className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 hover:bg-gray-50 transition-colors"
                        aria-label="Next media"
                      >
                        <ChevronRight size={20} color="#4B5563" />
                      </button>
                    </div>
                  )}
                </div>
              )}
              {mediaType == 'videos' && videos.length === 0 && (
                <div
                  style={{
                    width: '100%',
                    // height: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#576C89',
                    height: '12.5rem',
                  }}
                >
                  No {mediaType} available
                </div>
              )}
            </div>
          )
        }
        <hr className="flex sm:hidden border-t border-gray-300 w-full" />
        {/* Professional Overview and Specialty Skills Section */}
        {((user?.show_bio_skills ?? true) || currentUser?.uuid === user?.uuid) && (
          <div
            className={`flex ${isMobile ? 'flex-col' : 'flex-row'} items-start p-0 w-full ${isMobile ? 'gap-8' : ''
              }`}
            style={isMobile ? {} : { gap: '60px' }}
          >
            {/* Professional Overview */}
            <div
              className={`flex flex-col items-start p-0 ${isMobile ? 'gap-3 w-full flex-none' : 'gap-5 flex-1'
                }`}
              style={isMobile ? {} : { width: '32.5rem', maxWidth: '32.5rem' }}
            >
              <h2
                className={`w-full ${isMobile ? 'h-auto text-lg leading-7' : 'h-7 text-xl leading-7'
                  } font-semibold m-0`}
                style={{ color: '#0D1621' }}
              >
                Professional Overview
              </h2>
              <p
                className={`w-full ${isMobile ? 'text-base' : 'text-lg'} `}
                style={{
                  letterSpacing: '0.02em',
                  color: '#333333',
                  wordWrap: 'break-word',
                  whiteSpace: 'pre-line',
                }}
              >
                {generalInformation || 'No professional overview available.'}
              </p>
            </div>

            {/* Specialty Skills */}
            <div
              className={`flex flex-col items-start p-0 ${isMobile ? 'gap-3 w-full flex-none' : 'gap-5 flex-none'
                }`}
              style={isMobile ? {} : { width: '25rem' }}
            >
              <h2
                className={`w-full ${isMobile ? 'h-auto text-lg leading-7' : 'h-7 text-xl leading-7'
                  } font-semibold m-0`}
                style={{ color: '#0D1621' }}
              >
                Specialty Skills
              </h2>
              <div className="flex flex-row flex-wrap items-start content-start py-2.5 w-full gap-y-2.5 gap-x-1.5">
                {skills.length > 0 ? (
                  skills.map((skill) => (
                    <div
                      key={skill.id}
                      className={`box-border flex flex-row justify-center items-center gap-1.5 rounded-full ${isMobile ? 'px-4 py-1.5 h-8' : 'px-5 py-2 h-9'
                        }`}
                      style={{ background: '#E9EEF6' }}
                    >
                      <div
                        className={`text-center ${isMobile ? 'text-xs leading-4' : 'text-sm leading-5'
                          } font-medium`}
                        style={{ color: '#0D1621' }}
                      >
                        {skill.name}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className={`${isMobile ? 'text-xs' : 'text-sm'}`} style={{ color: '#576C89' }}>
                    No specialty skills available.
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {
          showMediaBig != null && (
            <>
              <ViewMediaModel
                kit_document={showMediaBig}
                dialogCloseHandler={function (): void {
                  setshowMediaBig(null);
                }}
              />
            </>
          )
        }
      </div>
    </>
  );
};

export default About;

